import React, { FC } from 'react';

import { Box, Button2, Stack, Typography, useDesktop, useMediaSwitch, useTablet, useMobile } from 'Modules/ui3';
import { useConfig } from 'Modules/core/config';

import { useHeaderContext } from '../../components/Header/HeaderContextProvider';


interface ChipProps {
    text: string;
    isTablet: boolean;
    isMobile: boolean;
}
const Chip: FC<ChipProps> = ({ text, isTablet, isMobile }) => (
    <Box
        py={isTablet ? 3 : 2}
        px={!isMobile ? 4 : 3}
        borderRadius={8}
        bgcolor='rgba(255, 255, 255, 0.08)'
        sx={{ backdropFilter: 'blur(8px)' }}
    >
        <Typography
            fontFamily='Hauora'
            fontSize={isMobile ? '12px' : '16px'}
            fontWeight={500}
            lineHeight={isMobile ? '16px' : '24px'}
            color='#DBDBDB'
            textAlign='center'
        >
            {text}
        </Typography>
    </Box>
);

export const Head: FC = () => {
    const isDesktop = useDesktop();
    const isTablet = useTablet();
    const isMobile = useMobile();
    const showAuthorization = useConfig('showAuthorization');
    const lkflUrl = useConfig('lkflUrl');
    const { triggerRef } = useHeaderContext();
    return (
        <Box {...isDesktop && { px: 2, pt: 2 }}>
            <Stack
                position='relative'
                overflow='hidden'
                height={useMediaSwitch('98vh', '712px', '512px')}
                alignItems={isDesktop ? 'flex-start' : 'center'}
                bgcolor='#0C0C0C'
                {...isDesktop && {
                    p: 2,
                    borderRadius: '48px',
                }}
                sx={{
                    outline: '2px solid #fff',
                    outlineOffset: '-1px',
                }}
            >
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    poster="data:image/svg+xml;utf8,<svg xmlns='http://w3.org' width='100% header' height='100%'><rect width='100%' height='100%' fill='%230C0C0C'/></svg>"
                    style={{
                        position: 'absolute',
                        display: 'block',
                        top: 0,
                        left: 0,
                        width: isDesktop ? '100%' : 'auto',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: 1,
                        backgroundColor: 'transparent',
                    }}
                    ref={el => {
                        if (el) {
                            el.setAttribute('muted', '');
                            el.defaultMuted = true;
                            el.muted = true;
                        }
                    }}
                >
                    <source src='/Frontend/videos/Mainanimations.mp4' />
                </video>
                <Stack
                    pt={useMediaSwitch(12, 6, 5)}
                    px={useMediaSwitch(12, 6, 5)}
                    pb={useMediaSwitch(12, 22, 15)}
                    height='100%'
                    justifyContent='flex-end'
                    spacing={useMediaSwitch(22, 16, 12)}
                    position='relative'
                    zIndex={2}
                >
                    <Stack spacing={isDesktop ? 12 : 6}>
                        <Stack
                            direction='row'
                            justifyContent={isDesktop ? 'flex-start' : 'center'}
                            spacing={useMediaSwitch(4, 6, 2)}
                        >
                            <Chip text='Более 450 выпусков' isTablet={isTablet} isMobile={isMobile} />
                            <Chip text={`ТОП-1${!isMobile ? ' по числу' : ''} пользователей`} isTablet={isTablet} isMobile={isMobile} />
                        </Stack>
                        <Stack spacing={useMediaSwitch(8, 6, 4)} alignItems={isDesktop ? 'flex-start' : 'center'}>
                            <Typography
                                component='h1'
                                color='grayscale.shade0'
                                fontSize={useMediaSwitch('72px', '56px', '32px')}
                                lineHeight={isDesktop ? '1.1' : '1.2'}
                                fontWeight='600'
                                fontFamily='Hauora'
                                {...!isDesktop && {
                                    textAlign: 'center',
                                }}
                            >
                                Инвестируйте в {isDesktop ? 'цифровые' : 'ЦФА'}
                                {isDesktop && (
                                    <Typography component='span' fontSize='72px' lineHeight='1.1' fontWeight='600' fontFamily='Hauora' color='rgba(255, 255, 255, 0.70)'>
                                        <br />финансовые активы
                                    </Typography>
                                )}
                            </Typography>
                            <Typography
                                component='span'
                                color='grayscale.shade0'
                                fontSize={isMobile ? '16px' : '20px'}
                                lineHeight={isMobile ? '1.5' : '1.6'}
                                fontWeight='500'
                                fontFamily='Hauora'
                                textAlign='center'
                            >
                                Новые выпуски от российских компаний каждый день
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack
                        direction='row'
                        justifyContent={isDesktop ? 'flex-start' : 'center'}
                        height={({ spacing }) => spacing(isDesktop ? 16 : 14)}
                    >
                        {showAuthorization && (
                            <Button2
                                LinkComponent='a'
                                href={lkflUrl}
                                variant={isDesktop ? 'stroke' : 'primary'}
                                variantType='main'
                                size='large'
                                fullWidth={isMobile}
                                sx={{
                                    fontFamily: 'Hauora',
                                    fontWeight: 700,
                                    fontSize: isDesktop ? '18px' : '16px',
                                    px: isDesktop ? 12 : 6,
                                    borderRadius: 5,
                                    boxShadow: '0 0 40px 0 rgba(0, 0, 0, 0.06)',
                                    ...!isDesktop && {
                                        bgcolor: '#242424',
                                    },
                                }}
                            >
                                Зарегистрироваться
                            </Button2>
                        )}
                    </Stack>
                </Stack>
                <div ref={triggerRef} style={{ height: '1px', marginTop: '-1px' }} />
            </Stack>
        </Box>
    );
};
